import { render, staticRenderFns } from "./create-worker.vue?vue&type=template&id=852c0cf0&scoped=true"
import script from "./create-worker.vue?vue&type=script&lang=js"
export * from "./create-worker.vue?vue&type=script&lang=js"
import style0 from "./create-worker.vue?vue&type=style&index=0&id=852c0cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852c0cf0",
  null
  
)

export default component.exports